import { MutationTree, Payload } from 'vuex';
import { LicenseListState } from './types';

export const mutations: MutationTree<LicenseListState> = {
};
